@let gridData = $gridData();
@let T = gridData.data;
<unity-grid-shared
  [gridTitle]="$gridTitle()"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="reference_number_display" title="Expense Id">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared
        [displayText]="item.reference_number_display"
        [link]="['/agreement', $agreementId(), 'client-expense', item.id]" />
    </ng-template>
  </kendo-grid-column>
  @if (this.$isClientView()) {
    <kendo-grid-column field="client.reference_number_display" title="Client Id">
      <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
        <unity-link-gridcell-shared
          [displayText]="item.client.reference_number_display"
          [link]="['/agreement', $agreementId(), 'client', item.client.id]" />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="client.first_name" title="Client First Name">
      <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
        <unity-link-gridcell-shared
          [displayText]="item.client.first_name ?? ''"
          [link]="['/agreement', $agreementId(), 'client', item.client.id]" />
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="client.last_name" title="Client Last Name">
      <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
        <unity-link-gridcell-shared
          [displayText]="item.client.last_name ?? ''"
          [link]="['/agreement', $agreementId(), 'client', item.client.id]" />
      </ng-template>
    </kendo-grid-column>
  }
  <kendo-grid-column field="amount" title="Amount" filter="numeric">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      @if (item.amount) {
        <unity-gridcell-currency-shared [value]="item.amount" />
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="type_of_expense" title="Type of Expense" [filterable]="false" [sortable]="false">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      @if (item['type_of_expense']) {
        {{ getDisplayValue(item['type_of_expense'], 'type_of_expense') }}
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="date" title="Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      @if (item.date) {
        {{ item.date | dateTimezone: 'MM/dd/yyyy' }}
      }
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="notes" title="Notes" [filterable]="false">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <span [title]="item['Notes']">
        @if (item['Notes'] && item['Notes'].length > 30) {
          {{ `${item['Notes'].slice(0, 30)}...` }}
        } @else if (item['Notes']) {
          {{ item['Notes'] }}
        }
      </span>
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
